import CryptoJS from "crypto-js";
import forge from "node-forge";
import { v4 } from "uuid";
let secretKey = process.env.REACT_APP_CRYPTO_KEY;
let key = process.env.REACT_APP_ENCRYPTION_KEY;
// Encrypt data
const encryptData = (data) => {
    const encryptedData = CryptoJS.AES.encrypt(JSON.stringify(data), secretKey).toString();
    return encryptedData;
};
  
// Decrypt data
const decryptData = (encryptedData) => {
    const bytes = CryptoJS.AES.decrypt(encryptedData, secretKey);
    const decryptedData = JSON.parse(bytes.toString(CryptoJS.enc.Utf8));
    return decryptedData;
};

key = decodeURIComponent(key);

function generateUUID(length = 36) {
  const uuidV = v4().slice(0, length);
  return uuidV;
}
function encryptWithNF(text) {
  let iv = generateUUID(16);
  let cipher = forge.cipher.createCipher("AES-CBC", key);
  cipher.start({ iv: iv });
  cipher.update(forge.util.createBuffer(text, "utf8"));
  cipher.finish();
  let encrypted = cipher.output;
  let d = forge.util.encode64(encrypted.data);
  return `${d}|${iv}`;
}
function decryptWithNF(encryptedText) {
  const splittedText = encryptedText?.split("|");
  const [encData, iv] = [splittedText[0], splittedText[1]];
  let decipher = forge.cipher.createDecipher("AES-CBC", key);
  decipher.start({ iv: iv });
  decipher.update(forge.util.createBuffer(forge.util.decode64(encData)));
  let result = decipher.finish();
  if (result) {
    return decipher.output.data;
  } else {
    throw new Error("Could not decrypt");
  }
}

export {encryptData, decryptData, encryptWithNF, decryptWithNF}



  